import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'

import enMessages from './messages/en.json'

export const uicMessages = {
  en: enMessages,
}

const propTypes = {
  /**
   * App root
   */
  children: PropTypes.node.isRequired,
  /**
   * App locale
   */
  locale: PropTypes.string,
}

/**
 * Provides localized messages for the app
 */
function I18nProvider(props) {
  const { children, locale = 'en' } = props ?? {}
  const messages = uicMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

I18nProvider.propTypes = propTypes

export default I18nProvider
